import { ShiftRequestStatusEnum, ShiftStatusEnum } from '@umss/shared/utils';
import {
  PayPeriodStatsDto,
  UrgentShiftDto,
  UpcomingShiftDto,
  DashboardShiftRequestDto
} from '../dtos';

/**
 * Mock upcoming shifts for dashboard
 * Used as fallback when backend API is unavailable
 */
export const MOCK_UPCOMING_SHIFTS: UpcomingShiftDto[] = [
  {
    id: 'shift-1',
    facilityId: 'facility-1',
    facilityName: 'Alpine Valley Hospital',
    facilityFullAddress: '1234 Alpine Way, Salt Lake City, UT 84101',
    contractorId: 'contractor-1',
    contractorName: 'Uriah Montgomery',
    scopeOfPractice: 1,
    scopeOfPracticeDisplay: 'LPN',
    shiftType: 0,
    shiftTypeDisplay: 'Regular',
    shiftDate: '2025-09-17',
    startTime: '19:00:00',
    endTime: '06:00:00',
    hourlyRate: 32.0,
    specialInstructions: 'Check in at main entrance',
    status: ShiftRequestStatusEnum.Accepted,
    statusDisplay: 'Confirmed',
    confirmedAt: '2025-09-10T14:00:00Z',
    confirmedByName: 'Sarah Admin',
    estimatedHours: 11,
    estimatedPayment: 352.0
  },
  {
    id: 'shift-2',
    facilityId: 'facility-2',
    facilityName: 'Mountain View Hospital',
    facilityFullAddress: '5678 Mountain Rd, Provo, UT 84604',
    contractorId: 'contractor-1',
    contractorName: 'Uriah Montgomery',
    scopeOfPractice: 1,
    scopeOfPracticeDisplay: 'LPN',
    shiftType: 0,
    shiftTypeDisplay: 'Regular',
    shiftDate: '2025-09-18',
    startTime: '19:00:00',
    endTime: '06:00:00',
    hourlyRate: 34.0,
    status: ShiftRequestStatusEnum.Accepted,
    statusDisplay: 'Confirmed',
    confirmedAt: '2025-09-11T10:00:00Z',
    confirmedByName: 'Mike Supervisor',
    estimatedHours: 11,
    estimatedPayment: 374.0
  },
  {
    id: 'shift-3',
    facilityId: 'facility-3',
    facilityName: 'Timpanogos Regional',
    facilityFullAddress: '750 W 800 N, Orem, UT 84057',
    contractorId: 'contractor-1',
    contractorName: 'Uriah Montgomery',
    scopeOfPractice: 1,
    scopeOfPracticeDisplay: 'LPN',
    shiftType: 0,
    shiftTypeDisplay: 'Regular',
    shiftDate: '2025-09-22',
    startTime: '19:00:00',
    endTime: '06:00:00',
    hourlyRate: 30.0,
    status: ShiftRequestStatusEnum.Accepted,
    statusDisplay: 'Confirmed',
    confirmedAt: '2025-09-12T09:00:00Z',
    confirmedByName: 'Lisa Coordinator',
    estimatedHours: 11,
    estimatedPayment: 330.0
  }
];

/**
 * Mock shift requests (pending) for dashboard
 */
export const MOCK_SHIFT_REQUESTS: DashboardShiftRequestDto[] = [
  {
    id: 'request-1',
    shiftNeedId: 'need-1',
    contractorId: 'contractor-1',
    contractorName: 'Uriah Montgomery',
    latestCounterOfferRate: 35.0,
    message: 'Available for this shift',
    status: ShiftRequestStatusEnum.Pending,
    requestedAt: '2025-09-14T10:00:00Z',
    facilityId: 'facility-1',
    facilityName: 'Alpine Valley Hospital',
    facilitySubtypeId: 1,
    facilitySubtypeName: 'Cardiac ICU',
    facilityFullAddress: '1234 Alpine Way, Salt Lake City, UT 84101',
    scopeOfPractice: 1,
    scopeOfPracticeDisplay: 'LPN',
    shiftDate: '2025-09-17',
    startTime: '19:00:00',
    endTime: '06:00:00',
    shiftNeedHourlyRate: 32.0
  }
];

/**
 * Mock pay period stats for dashboard
 * Used as fallback when backend API is unavailable
 */
export const MOCK_PAY_PERIOD_STATS: PayPeriodStatsDto = {
  hoursWorked: 24,
  estimatedGrossPay: 768,
  hoursScheduled: 16,
  periodStartDate: '2024-12-16',
  periodEndDate: '2024-12-22',
  totalMilesDriven: 100,
  periodTrend: 'up'
};

export const MOCK_EARNING_SUMMARY = new Map([
  [
    'week',
    {
      direction: 'up',
      distanceMiles: 10,
      label: 'This week',
      timeDisplay: 'Dec 28 - Jan 3, 2026',
      totalAmount: 51,
      totalHours: 5
    }
  ],
  [
    'month',
    {
      direction: 'up',
      distanceMiles: 50,
      label: 'This month',
      timeDisplay: 'Jan 1 - 31',
      totalAmount: 451,
      totalHours: 20
    }
  ],
  [
    'year',
    {
      direction: 'up',
      distanceMiles: 300,
      label: 'Year to Date',
      timeDisplay: 'Jan 1 - Jan 2, 2026',
      totalAmount: 1523,
      totalHours: 100
    }
  ]
]);

/**
 * Mock urgent shift for dashboard alert
 */
export const MOCK_URGENT_SHIFT: UrgentShiftDto = {
  id: 'urgent-1',
  facilityId: 'facility-1',
  facilityName: 'Alpine Valley Hospital',
  facilityLocation: {
    id: 1,
    addressLine1: '123 Hospital Way',
    addressLine2: undefined,
    city: 'Provo',
    stateCode: 'UT',
    stateName: 'Utah',
    zipCode: '84601',
    countryCode: 'US',
    latitude: 40.2338,
    longitude: -111.6585,
    fullAddress: '123 Hospital Way, Provo, UT 84601'
  },
  facilityFullAddress: '123 Hospital Way, Provo, UT 84601',
  facilitySubtypeId: 1,
  facilitySubtypeName: 'Cardiac ICU',
  scopeOfPractice: 'Lpn',
  scopeOfPracticeDisplay: 'LPN',
  shiftDate: '2025-09-17',
  startTime: '19:00:00',
  endTime: '06:00:00',
  hourlyRate: 38.4,
  percentageIncrease: 20,
  specialInstructions: 'Urgent coverage needed - 20% higher rate',
  status: ShiftStatusEnum.Posted
};
